import * as React from 'react';
import {observer} from 'mobx-react';
import {PageCheckoutPanelProps} from './page-checkout-panels';
import {PageCheckoutTracks} from './page-checkout-tracks';
import {ButtonCircle} from './button-circle';
import {classes, style} from 'typestyle';
import {SVGIcon} from './svg-icon';
import {transitionQuickEase} from '../theme/transition';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import {colorSlate} from '../theme/color';
import {important, px} from 'csx';
import {ArtistSchema, TrackSchema} from '../types/schema';
import {ImagePreloader} from '../types/fn';

export interface PageCheckoutContentStep2Props extends PageCheckoutPanelProps {
  PlayButton: any;
  BrandSponsoredLabel: any;
  preload: ImagePreloader;
  preloadWaveform: ImagePreloader;
  onClickLink(event: React.MouseEvent<any>): void;
  i18n?: {
    title: string;
  }
}

export interface PageCheckoutContentStep2State {
  expand: boolean;
}

const DEFAULT_I18N = {
  title: 'Your tracks'
};

@observer
export class PageCheckoutContentStep2 extends React.Component<PageCheckoutContentStep2Props, PageCheckoutContentStep2State> {
  constructor(props) {
    super(props);
    this.state = { expand: false };
  }

  render() {
    const { model, i18n = DEFAULT_I18N, PlayButton, BrandSponsoredLabel, preload, preloadWaveform, onClickLink } = this.props;
    const { expand } = this.state;

    return (
      <div className={PageCheckoutContentStep2.styles.container}>
        <h5 onClick={this.toggleExpand}>{i18n.title}</h5>
        <ButtonCircle onClick={this.toggleExpand} size={30} className={PageCheckoutContentStep2.styles.expander}>
          <SVGIcon.ArrowRight size={10} className={classes(PageCheckoutContentStep2.styles.chevron, expand ? PageCheckoutContentStep2.styles.chevronExpand : PageCheckoutContentStep2.styles.chevronCollapse)} />
        </ButtonCircle>
        <PageCheckoutTracks
          className={classes(PageCheckoutContentStep2.styles.tracks, expand ? PageCheckoutContentStep2.styles.tracksExpand : PageCheckoutContentStep2.styles.tracksCollapse)}
          PlayButton={PlayButton}
          BrandSponsoredLabel={BrandSponsoredLabel}
          model={model}
          collapsed={model.expanded}
          preload={preload}
          preloadWaveform={preloadWaveform}
          onClickLink={onClickLink}
        />
      </div>
    )
  }

  toggleExpand = () => this.setState({ expand: !this.state.expand });

  static styles = {
    container: style({
      position: 'relative',
      $nest: {
        '&>h5': {
          margin: 0
        }
      }
    }),
    expander: style(
      {
        position: 'absolute',
        top: px(-5),
        right: px(-10),
        backgroundColor: important('transparent'),
        $nest: {
          '& g': {
            stroke: colorSlate.toString(),
          }
        },
      },
      mediaTablet({
        display: important('none')
      })
    ),
    chevron: style({
      transition: `transform ${transitionQuickEase}`
    }),
    chevronCollapse: style({
      transform: `rotate(90deg)`,
    }),
    chevronExpand: style({
      transform: `rotate(270deg)`
    }),
    tracks: style({
      margin: '1rem 0 0 0'
    }),
    tracksCollapse: style(mediaMobileOnly({
      display: 'none'
    })),
    tracksExpand: style(mediaMobileOnly({
      display: 'block'
    }))
  }
};